import pino from "pino";
import { getLogContext, redactText } from "./logDiagnostics";

const serverConsoleLogger = pino({
  level: typeof process != "undefined" ? (process?.env.LOG_LEVEL ?? "info") : "info",
  timestamp: pino.stdTimeFunctions.isoTime,
});

type ConsoleMethod = "debug" | "info" | "log" | "warn" | "error";
type PinoMethod = "debug" | "info" | "warn" | "error";

const pinoMethodByConsoleMethod: Record<ConsoleMethod, PinoMethod> = {
  debug: "debug",
  info: "info",
  log: "info",
  warn: "warn",
  error: "error",
};

export function installServerConsoleLogger() {
  const consoleWithFlag = globalThis.console as Console & {
    __cabocheckPinoInstalled?: boolean;
  };

  if (consoleWithFlag.__cabocheckPinoInstalled) {
    return;
  }

  consoleWithFlag.__cabocheckPinoInstalled = true;

  for (const method of ["debug", "info", "log", "warn", "error"] as const) {
    consoleWithFlag[method] = ((...args: unknown[]) => {
      logToPino(method, args);
    }) as Console[typeof method];
  }
}

function logToPino(method: ConsoleMethod, args: unknown[]) {
  const pinoMethod = pinoMethodByConsoleMethod[method];

  if (args.length === 0) {
    serverConsoleLogger[pinoMethod]("");
    return;
  }

  const [first, ...rest] = args;

  if (typeof first === "string") {
    const context = getLogContext(rest);
    serverConsoleLogger[pinoMethod](context, redactText(first));
    return;
  }

  if (first instanceof Error) {
    serverConsoleLogger[pinoMethod](getLogContext(args), "Application error");
    return;
  }

  serverConsoleLogger[pinoMethod](getLogContext(args), "console." + method);
}
